import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash-es";

import { AppThunk } from "../store";
import { Cluster, Organization } from "../store/pomeriumApi";
import { OrganizationState, organizationId } from "../types/organizations";

const initialState: OrganizationState = {
  byId: {},
  clustersByOrg: {},
  orgClusterUiOpen: false,
};

const slice = createSlice({
  name: "organizations",
  initialState,
  reducers: {
    setById(
      state: OrganizationState,
      action: PayloadAction<Record<organizationId, Organization>>,
    ): void {
      state.byId = action.payload;
    },
    setOrgClusters(
      state: OrganizationState,
      action: PayloadAction<{ organizationId: string; clusters: Cluster[] }>,
    ): void {
      state.clustersByOrg[action.payload.organizationId] =
        action.payload.clusters;
    },
    setOrgClusterOpen(
      state: OrganizationState,
      action: PayloadAction<boolean>,
    ): void {
      state.orgClusterUiOpen = action.payload;
    },
  },
});

export const { reducer, actions } = slice;
export const { setOrgClusterOpen, setOrgClusters } = actions;

export const indexOrganizations =
  (organizations: Organization[]): AppThunk =>
  async (dispatch): Promise<void> => {
    const byId = {};
    organizations.forEach((organization) => {
      set(byId, organization.id, organization);
    });
    dispatch(slice.actions.setById(byId));
  };
